<template>
	<div>
		<h3 class="popup-tilte">Figyelmeztetés!</h3>
		<div class="fs-desc popup-content-width">
            Biztos, hogy szerződéskötési módot vált?
        </div>

		<div class="popup-form form">
			<div class="d-flex mt-23px">
                <button type="button" class="btn btn-blue mt-30px mr-4" @click="showPopup(null)">Mégse</button>
				<button type="button" class="btn btn-danger mt-30px ml-4" @click="handleAccept">Igen</button>
			</div>
		</div>
	</div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';

export default {
    computed: {
        ...mapGetters('contracting',['getBrokerageData']),
        ...mapGetters(['getOffers']),
        offers() {
            const data = this.getOffers(null);
            const missing = {};
            for (const [key, value] of Object.entries(data.missing)) {
                missing[key] = {...value};
            }
            return {
                ...data,
                missing,
            };
        }
    },
	methods: {
		...mapMutations(['showPopup']),
        ...mapMutations('contracting', ['setNewContractType']),
        ...mapActions('contracting', ['setContractType']),
		async handleAccept() {
            if (this.getBrokerageData.newType) {
                await this.setContractType({
                    contract_id: this.getBrokerageData?.contract_id,
                    type: this.getBrokerageData.newType,
                    offers: this.offers,
                });
                this.setNewContractType(null);
            }
            this.showPopup(null);
        },
	},
};
</script>
